import * as React from 'react';
import { Controller, Menu, Toolbar, MainMenu } from '@tencent/workbench';
import { InsertPlaceFeature } from './insert-place-feature';
import {
    MENU_CONFIGS,
    TOOLBAR_CONFIGS,
    config,
    bodyConfig,
    bodyConfigV,
    contentConfig,
    contentConfigV,
    picConfig,
    tableConfig,
} from './config';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';

@Controller({
    toolbarItems: TOOLBAR_CONFIGS,
    menuItems: MENU_CONFIGS,
})
export class InsertPlaceController {
    constructor(private readonly insertPlaceFeature: InsertPlaceFeature) {}

    @Toolbar(config.id, 'dropdownContent')
    @Toolbar(wrapIdForBig(config.id), 'dropdownContent')
    public insertDropdown() {
        return <MainMenu
            align="left"
            name={config.id}
            mode="menu"
            itemStyle={{ width: 166 }}
        />;
    }

    @Menu(config.id, 'shouldDisabled')
    @Toolbar(config.id, 'shouldDisabled')
    @Toolbar(wrapIdForBig(config.id), 'shouldDisabled')
    public shouldDisabled() {
        return this.insertPlaceFeature.shouldDisabled(config.id);
    }

    @Menu(config.id, 'shouldHide')
    @Toolbar(config.id, 'shouldHide')
    @Toolbar(wrapIdForBig(config.id), 'shouldHide')
    public shouldHide() {
        return !(this.insertPlaceFeature.curModelIsLayout || this.insertPlaceFeature.curModelIsMaster);
    }


    @Menu(contentConfig.id, 'onClick')
    public onAddContentPl() {
        this.insertPlaceFeature.insertElement(contentConfig.id);
    }

    @Menu(contentConfigV.id, 'onClick')
    public onAddContentVPl() {
        this.insertPlaceFeature.insertElement(contentConfigV.id);
    }

    @Menu(bodyConfig.id, 'onClick')
    public onAddBodyPl() {
        this.insertPlaceFeature.insertElement(bodyConfig.id);
    }

    @Menu(bodyConfigV.id, 'onClick')
    public onAddBodyVPl() {
        this.insertPlaceFeature.insertElement(bodyConfigV.id);
    }

    @Menu(picConfig.id, 'onClick')
    public onAddPicturePl() {
        this.insertPlaceFeature.insertElement(picConfig.id);
    }

    @Menu(tableConfig.id, 'onClick')
    public onAddTablePl() {
        this.insertPlaceFeature.insertElement(tableConfig.id);
    }
}
